import { mod } from "@hex-insights/core";
import { settings } from "@hex-insights/forms";
import { Reforge } from "@hex-insights/uploads";
import { getReforgeImageURL, MediaAttachment } from "../../../../Utilities";
import { MediaAttachmentUtilities } from "../../../Utilities";

const preloadRange = 2;

export function getPreloadMediaAttachments<T extends Pick<MediaAttachment, "id" | "fileKey" | "fileContentType">>(
	mediaAttachments: T[],
	index: number,
) {
	const indices = new Set<number>();
	for (let i = 0; i < preloadRange; i++) {
		const forwardIndex = mod(index + i + 1, mediaAttachments.length);
		if (forwardIndex !== index && !indices.has(forwardIndex)) {
			indices.add(forwardIndex);
		}
		const backwardIndex = mod(index - i - 1, mediaAttachments.length);
		if (backwardIndex !== index && !indices.has(backwardIndex)) {
			indices.add(backwardIndex);
		}
	}

	const preloadAttachments: T[] = [];
	indices.forEach((i) => {
		const attachment = mediaAttachments[i];
		if (MediaAttachmentUtilities.isImage(attachment)) {
			preloadAttachments.push(attachment);
		}
	});
	return preloadAttachments;
}

// TODO add to core
export function preloadMediaAttachment(
	{ fileKey, fileContentType }: Pick<MediaAttachment, "fileKey" | "fileContentType">,
	edits?: Reforge.ImageOptions["edits"],
) {
	let src = settings.uploads.fileInfoToURL(fileKey, fileContentType);
	if (fileKey && edits) {
		src = getReforgeImageURL(fileKey, edits);
	}
	const image = new Image();
	image.src = src;
}
